import { useSelector } from 'react-redux';
import { AppState } from '../app/AppState';

export const useIsPermissionsInitialized = (): boolean => {
    const perm = useSelector((s: AppState) => s.Permissions);
    return perm.get('initialized') ?? false;
};
